import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _45f6f74a = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _28076b4d = () => interopDefault(import('../../../pages/buscadores.vue' /* webpackChunkName: "pages/buscadores" */))
const _0ed68952 = () => interopDefault(import('../../../pages/change-password.vue' /* webpackChunkName: "pages/change-password" */))
const _2b2455b6 = () => interopDefault(import('../../../pages/como-funciona.vue' /* webpackChunkName: "pages/como-funciona" */))
const _fe11563e = () => interopDefault(import('../../../pages/configuracion.vue' /* webpackChunkName: "pages/configuracion" */))
const _5b658a80 = () => interopDefault(import('../../../pages/dot-grid.vue' /* webpackChunkName: "pages/dot-grid" */))
const _cb89767a = () => interopDefault(import('../../../pages/empresas/index.vue' /* webpackChunkName: "pages/empresas/index" */))
const _10fcd780 = () => interopDefault(import('../../../pages/empresas-demo.vue' /* webpackChunkName: "pages/empresas-demo" */))
const _ce9119d8 = () => interopDefault(import('../../../pages/empresas-piloto.vue' /* webpackChunkName: "pages/empresas-piloto" */))
const _49450496 = () => interopDefault(import('../../../pages/empresas-reporteria.vue' /* webpackChunkName: "pages/empresas-reporteria" */))
const _b57ad94e = () => interopDefault(import('../../../pages/experiencias/index.vue' /* webpackChunkName: "pages/experiencias/index" */))
const _60b214ca = () => interopDefault(import('../../../pages/inicio.vue' /* webpackChunkName: "pages/inicio" */))
const _aa874a34 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _2b37f200 = () => interopDefault(import('../../../pages/mantenimiento.vue' /* webpackChunkName: "pages/mantenimiento" */))
const _0e12f6ec = () => interopDefault(import('../../../pages/mi-inventario-habilidades/index.vue' /* webpackChunkName: "pages/mi-inventario-habilidades/index" */))
const _021fae7c = () => interopDefault(import('../../../pages/mi-piloto.vue' /* webpackChunkName: "pages/mi-piloto" */))
const _1c864ad5 = () => interopDefault(import('../../../pages/mis-proyectos/index.vue' /* webpackChunkName: "pages/mis-proyectos/index" */))
const _5600656b = () => interopDefault(import('../../../pages/mis-trabajadores/index.vue' /* webpackChunkName: "pages/mis-trabajadores/index" */))
const _72703388 = () => interopDefault(import('../../../pages/nuestra-propuesta.vue' /* webpackChunkName: "pages/nuestra-propuesta" */))
const _263f5082 = () => interopDefault(import('../../../pages/ocupaciones/index.vue' /* webpackChunkName: "pages/ocupaciones/index" */))
const _003f5b07 = () => interopDefault(import('../../../pages/ocupaciones-personalizadas/index.vue' /* webpackChunkName: "pages/ocupaciones-personalizadas/index" */))
const _62ac1f72 = () => interopDefault(import('../../../pages/oportunidades/index.vue' /* webpackChunkName: "pages/oportunidades/index" */))
const _e697b4fc = () => interopDefault(import('../../../pages/perfil.vue' /* webpackChunkName: "pages/perfil" */))
const _5824a234 = () => interopDefault(import('../../../pages/perfil-empleado.vue' /* webpackChunkName: "pages/perfil-empleado" */))
const _2c287a1e = () => interopDefault(import('../../../pages/permissions-test.vue' /* webpackChunkName: "pages/permissions-test" */))
const _6dc08b37 = () => interopDefault(import('../../../pages/piloto-cesantes/index.vue' /* webpackChunkName: "pages/piloto-cesantes/index" */))
const _0a2f0736 = () => interopDefault(import('../../../pages/politica-tratamiento-datos.vue' /* webpackChunkName: "pages/politica-tratamiento-datos" */))
const _577a650c = () => interopDefault(import('../../../pages/politicas-de-privacidad.vue' /* webpackChunkName: "pages/politicas-de-privacidad" */))
const _08330428 = () => interopDefault(import('../../../pages/preguntas-frecuentes.vue' /* webpackChunkName: "pages/preguntas-frecuentes" */))
const _475a0d3e = () => interopDefault(import('../../../pages/quienes-somos.vue' /* webpackChunkName: "pages/quienes-somos" */))
const _b263de2e = () => interopDefault(import('../../../pages/registro.vue' /* webpackChunkName: "pages/registro" */))
const _d6ccb37a = () => interopDefault(import('../../../pages/registro-old.vue' /* webpackChunkName: "pages/registro-old" */))
const _85b02d88 = () => interopDefault(import('../../../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _1339b5c1 = () => interopDefault(import('../../../pages/salir.vue' /* webpackChunkName: "pages/salir" */))
const _47b132ff = () => interopDefault(import('../../../pages/solicita-cuenta-empresa.vue' /* webpackChunkName: "pages/solicita-cuenta-empresa" */))
const _122bb39e = () => interopDefault(import('../../../pages/tests/index.vue' /* webpackChunkName: "pages/tests/index" */))
const _6868c1cb = () => interopDefault(import('../../../pages/cuestionarios/habilidades.vue' /* webpackChunkName: "pages/cuestionarios/habilidades" */))
const _1a9b08c0 = () => interopDefault(import('../../../pages/cuestionarios/instrucciones.vue' /* webpackChunkName: "pages/cuestionarios/instrucciones" */))
const _fd6e3f72 = () => interopDefault(import('../../../pages/cuestionarios/origen.vue' /* webpackChunkName: "pages/cuestionarios/origen" */))
const _7ad2bdd4 = () => interopDefault(import('../../../pages/empresas/potencial-de-match.vue' /* webpackChunkName: "pages/empresas/potencial-de-match" */))
const _54e2b6af = () => interopDefault(import('../../../pages/empresas/trabajador-potencial.vue' /* webpackChunkName: "pages/empresas/trabajador-potencial" */))
const _ce3f1bea = () => interopDefault(import('../../../pages/empresas/trabajadores-potenciales.vue' /* webpackChunkName: "pages/empresas/trabajadores-potenciales" */))
const _6f97fa15 = () => interopDefault(import('../../../pages/invitaciones/cesantes.vue' /* webpackChunkName: "pages/invitaciones/cesantes" */))
const _3a480c67 = () => interopDefault(import('../../../pages/invitaciones/empleados.vue' /* webpackChunkName: "pages/invitaciones/empleados" */))
const _47a8a23a = () => interopDefault(import('../../../pages/login/admin.vue' /* webpackChunkName: "pages/login/admin" */))
const _59e4bf5e = () => interopDefault(import('../../../pages/login/confirmation.vue' /* webpackChunkName: "pages/login/confirmation" */))
const _7abc5480 = () => interopDefault(import('../../../pages/login/persona.vue' /* webpackChunkName: "pages/login/persona" */))
const _3cfe5637 = () => interopDefault(import('../../../pages/mis-cuestionarios/nuevo/index.vue' /* webpackChunkName: "pages/mis-cuestionarios/nuevo/index" */))
const _37b1b9e8 = () => interopDefault(import('../../../pages/mis-proyectos/inventario-habilidades/index.vue' /* webpackChunkName: "pages/mis-proyectos/inventario-habilidades/index" */))
const _2fbe2586 = () => interopDefault(import('../../../pages/mis-proyectos/nuevo/index.vue' /* webpackChunkName: "pages/mis-proyectos/nuevo/index" */))
const _1d786d3e = () => interopDefault(import('../../../pages/ocupaciones-personalizadas/nueva/index.vue' /* webpackChunkName: "pages/ocupaciones-personalizadas/nueva/index" */))
const _844e2852 = () => interopDefault(import('../../../pages/ocupaciones-requeridas/cesantes/index.vue' /* webpackChunkName: "pages/ocupaciones-requeridas/cesantes/index" */))
const _4d699928 = () => interopDefault(import('../../../pages/ocupaciones/search.vue' /* webpackChunkName: "pages/ocupaciones/search" */))
const _95fea082 = () => interopDefault(import('../../../pages/oportunidades/pilotos/index.vue' /* webpackChunkName: "pages/oportunidades/pilotos/index" */))
const _0a98686a = () => interopDefault(import('../../../pages/oportunidades/reconversion-laboral/index.vue' /* webpackChunkName: "pages/oportunidades/reconversion-laboral/index" */))
const _a241e4e8 = () => interopDefault(import('../../../pages/piloto-cesantes/configuracion.vue' /* webpackChunkName: "pages/piloto-cesantes/configuracion" */))
const _857f46ba = () => interopDefault(import('../../../pages/piloto-cesantes/invitaciones.vue' /* webpackChunkName: "pages/piloto-cesantes/invitaciones" */))
const _8bdb8c5a = () => interopDefault(import('../../../pages/piloto-cesantes/persona-potencial.vue' /* webpackChunkName: "pages/piloto-cesantes/persona-potencial" */))
const _0eef0274 = () => interopDefault(import('../../../pages/preview/buscadores.vue' /* webpackChunkName: "pages/preview/buscadores" */))
const _18e0dd36 = () => interopDefault(import('../../../pages/preview/free-skills.vue' /* webpackChunkName: "pages/preview/free-skills" */))
const _193a1289 = () => interopDefault(import('../../../pages/preview/register-country.vue' /* webpackChunkName: "pages/preview/register-country" */))
const _72282dac = () => interopDefault(import('../../../pages/solicitudes/reuniones/index.vue' /* webpackChunkName: "pages/solicitudes/reuniones/index" */))
const _6b96cdfc = () => interopDefault(import('../../../pages/empresas/agregar-ocupacion/detalle.vue' /* webpackChunkName: "pages/empresas/agregar-ocupacion/detalle" */))
const _779fda58 = () => interopDefault(import('../../../pages/experiencias/nuevas/educativa.vue' /* webpackChunkName: "pages/experiencias/nuevas/educativa" */))
const _629b5a20 = () => interopDefault(import('../../../pages/experiencias/nuevas/habilidades-educativas.vue' /* webpackChunkName: "pages/experiencias/nuevas/habilidades-educativas" */))
const _4f3c0a90 = () => interopDefault(import('../../../pages/experiencias/nuevas/habilidades-laborales.vue' /* webpackChunkName: "pages/experiencias/nuevas/habilidades-laborales" */))
const _0e136c82 = () => interopDefault(import('../../../pages/experiencias/nuevas/laboral.vue' /* webpackChunkName: "pages/experiencias/nuevas/laboral" */))
const _595862fa = () => interopDefault(import('../../../pages/experiencias/nuevas/otras.vue' /* webpackChunkName: "pages/experiencias/nuevas/otras" */))
const _82158288 = () => interopDefault(import('../../../pages/ocupaciones-requeridas/cesantes/detalle.vue' /* webpackChunkName: "pages/ocupaciones-requeridas/cesantes/detalle" */))
const _38f49e3c = () => interopDefault(import('../../../pages/blog/categorias/_slug.vue' /* webpackChunkName: "pages/blog/categorias/_slug" */))
const _693abaa6 = () => interopDefault(import('../../../pages/experiencias/educativa/_id.vue' /* webpackChunkName: "pages/experiencias/educativa/_id" */))
const _3f726b4d = () => interopDefault(import('../../../pages/experiencias/laboral/_id.vue' /* webpackChunkName: "pages/experiencias/laboral/_id" */))
const _c2d16870 = () => interopDefault(import('../../../pages/experiencias/otra/_id.vue' /* webpackChunkName: "pages/experiencias/otra/_id" */))
const _3508e51e = () => interopDefault(import('../../../pages/invitaciones/entrevistas/_user.vue' /* webpackChunkName: "pages/invitaciones/entrevistas/_user" */))
const _8fbc5dc2 = () => interopDefault(import('../../../pages/invitaciones/enviadas/_code.vue' /* webpackChunkName: "pages/invitaciones/enviadas/_code" */))
const _82fa5660 = () => interopDefault(import('../../../pages/mis-proyectos/antiguo/_id/index.vue' /* webpackChunkName: "pages/mis-proyectos/antiguo/_id/index" */))
const _3b197d52 = () => interopDefault(import('../../../pages/oportunidades/reconversion-laboral/_id.vue' /* webpackChunkName: "pages/oportunidades/reconversion-laboral/_id" */))
const _0a147d56 = () => interopDefault(import('../../../pages/oportunidades/pilotos/_jobseekerfair/_id.vue' /* webpackChunkName: "pages/oportunidades/pilotos/_jobseekerfair/_id" */))
const _496439da = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _02381980 = () => interopDefault(import('../../../pages/mis-proyectos/_id/index.vue' /* webpackChunkName: "pages/mis-proyectos/_id/index" */))
const _16aec693 = () => interopDefault(import('../../../pages/mis-trabajadores/_id.vue' /* webpackChunkName: "pages/mis-trabajadores/_id" */))
const _42559a72 = () => interopDefault(import('../../../pages/ocupaciones-personalizadas/_id/index.vue' /* webpackChunkName: "pages/ocupaciones-personalizadas/_id/index" */))
const _57cf4b26 = () => interopDefault(import('../../../pages/ocupaciones/_id/index.vue' /* webpackChunkName: "pages/ocupaciones/_id/index" */))
const _f581534c = () => interopDefault(import('../../../pages/oportunidades/_id.vue' /* webpackChunkName: "pages/oportunidades/_id" */))
const _052a8330 = () => interopDefault(import('../../../pages/piloto/_slug.vue' /* webpackChunkName: "pages/piloto/_slug" */))
const _486ca24a = () => interopDefault(import('../../../pages/ocupaciones-personalizadas/_id/agregar-habilidades.vue' /* webpackChunkName: "pages/ocupaciones-personalizadas/_id/agregar-habilidades" */))
const _bf3884ee = () => interopDefault(import('../../../pages/mis-proyectos/_id/ocupaciones/_occupationId.vue' /* webpackChunkName: "pages/mis-proyectos/_id/ocupaciones/_occupationId" */))
const _3d6810e8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _45f6f74a,
    name: "blog___es"
  }, {
    path: "/buscadores",
    component: _28076b4d,
    name: "buscadores___es"
  }, {
    path: "/change-password",
    component: _0ed68952,
    name: "change-password___es"
  }, {
    path: "/como-funciona",
    component: _2b2455b6,
    name: "como-funciona___es"
  }, {
    path: "/configuracion",
    component: _fe11563e,
    name: "configuracion___es"
  }, {
    path: "/dot-grid",
    component: _5b658a80,
    name: "dot-grid___es"
  }, {
    path: "/empresas",
    component: _cb89767a,
    name: "empresas___es"
  }, {
    path: "/empresas-demo",
    component: _10fcd780,
    name: "empresas-demo___es"
  }, {
    path: "/empresas-piloto",
    component: _ce9119d8,
    name: "empresas-piloto___es"
  }, {
    path: "/empresas-reporteria",
    component: _49450496,
    name: "empresas-reporteria___es"
  }, {
    path: "/experiencias",
    component: _b57ad94e,
    name: "experiencias___es"
  }, {
    path: "/inicio",
    component: _60b214ca,
    name: "inicio___es"
  }, {
    path: "/login",
    component: _aa874a34,
    name: "login___es"
  }, {
    path: "/mantenimiento",
    component: _2b37f200,
    name: "mantenimiento___es"
  }, {
    path: "/mi-inventario-habilidades",
    component: _0e12f6ec,
    name: "mi-inventario-habilidades___es"
  }, {
    path: "/mi-piloto",
    component: _021fae7c,
    name: "mi-piloto___es"
  }, {
    path: "/mis-proyectos",
    component: _1c864ad5,
    name: "mis-proyectos___es"
  }, {
    path: "/mis-trabajadores",
    component: _5600656b,
    name: "mis-trabajadores___es"
  }, {
    path: "/nuestra-propuesta",
    component: _72703388,
    name: "nuestra-propuesta___es"
  }, {
    path: "/ocupaciones",
    component: _263f5082,
    name: "ocupaciones___es"
  }, {
    path: "/ocupaciones-personalizadas",
    component: _003f5b07,
    name: "ocupaciones-personalizadas___es"
  }, {
    path: "/oportunidades",
    component: _62ac1f72,
    name: "oportunidades___es"
  }, {
    path: "/perfil",
    component: _e697b4fc,
    name: "perfil___es"
  }, {
    path: "/perfil-empleado",
    component: _5824a234,
    name: "perfil-empleado___es"
  }, {
    path: "/permissions-test",
    component: _2c287a1e,
    name: "permissions-test___es"
  }, {
    path: "/piloto-cesantes",
    component: _6dc08b37,
    name: "piloto-cesantes___es"
  }, {
    path: "/politica-tratamiento-datos",
    component: _0a2f0736,
    name: "politica-tratamiento-datos___es"
  }, {
    path: "/politicas-de-privacidad",
    component: _577a650c,
    name: "politicas-de-privacidad___es"
  }, {
    path: "/preguntas-frecuentes",
    component: _08330428,
    name: "preguntas-frecuentes___es"
  }, {
    path: "/quienes-somos",
    component: _475a0d3e,
    name: "quienes-somos___es"
  }, {
    path: "/registro",
    component: _b263de2e,
    name: "registro___es"
  }, {
    path: "/registro-old",
    component: _d6ccb37a,
    name: "registro-old___es"
  }, {
    path: "/reports",
    component: _85b02d88,
    name: "reports___es"
  }, {
    path: "/salir",
    component: _1339b5c1,
    name: "salir___es"
  }, {
    path: "/solicita-cuenta-empresa",
    component: _47b132ff,
    name: "solicita-cuenta-empresa___es"
  }, {
    path: "/tests",
    component: _122bb39e,
    name: "tests___es"
  }, {
    path: "/cuestionarios/habilidades",
    component: _6868c1cb,
    name: "cuestionarios-habilidades___es"
  }, {
    path: "/cuestionarios/instrucciones",
    component: _1a9b08c0,
    name: "cuestionarios-instrucciones___es"
  }, {
    path: "/cuestionarios/origen",
    component: _fd6e3f72,
    name: "cuestionarios-origen___es"
  }, {
    path: "/empresas/potencial-de-match",
    component: _7ad2bdd4,
    name: "empresas-potencial-de-match___es"
  }, {
    path: "/empresas/trabajador-potencial",
    component: _54e2b6af,
    name: "empresas-trabajador-potencial___es"
  }, {
    path: "/empresas/trabajadores-potenciales",
    component: _ce3f1bea,
    name: "empresas-trabajadores-potenciales___es"
  }, {
    path: "/invitaciones/cesantes",
    component: _6f97fa15,
    name: "invitaciones-cesantes___es"
  }, {
    path: "/invitaciones/empleados",
    component: _3a480c67,
    name: "invitaciones-empleados___es"
  }, {
    path: "/login/admin",
    component: _47a8a23a,
    name: "login-admin___es"
  }, {
    path: "/login/confirmation",
    component: _59e4bf5e,
    name: "login-confirmation___es"
  }, {
    path: "/login/persona",
    component: _7abc5480,
    name: "login-persona___es"
  }, {
    path: "/mis-cuestionarios/nuevo",
    component: _3cfe5637,
    name: "mis-cuestionarios-nuevo___es"
  }, {
    path: "/mis-proyectos/inventario-habilidades",
    component: _37b1b9e8,
    name: "mis-proyectos-inventario-habilidades___es"
  }, {
    path: "/mis-proyectos/nuevo",
    component: _2fbe2586,
    name: "mis-proyectos-nuevo___es"
  }, {
    path: "/ocupaciones-personalizadas/nueva",
    component: _1d786d3e,
    name: "ocupaciones-personalizadas-nueva___es"
  }, {
    path: "/ocupaciones-requeridas/cesantes",
    component: _844e2852,
    name: "ocupaciones-requeridas-cesantes___es"
  }, {
    path: "/ocupaciones/search",
    component: _4d699928,
    name: "ocupaciones-search___es"
  }, {
    path: "/oportunidades/pilotos",
    component: _95fea082,
    name: "oportunidades-pilotos___es"
  }, {
    path: "/oportunidades/reconversion-laboral",
    component: _0a98686a,
    name: "oportunidades-reconversion-laboral___es"
  }, {
    path: "/piloto-cesantes/configuracion",
    component: _a241e4e8,
    name: "piloto-cesantes-configuracion___es"
  }, {
    path: "/piloto-cesantes/invitaciones",
    component: _857f46ba,
    name: "piloto-cesantes-invitaciones___es"
  }, {
    path: "/piloto-cesantes/persona-potencial",
    component: _8bdb8c5a,
    name: "piloto-cesantes-persona-potencial___es"
  }, {
    path: "/preview/buscadores",
    component: _0eef0274,
    name: "preview-buscadores___es"
  }, {
    path: "/preview/free-skills",
    component: _18e0dd36,
    name: "preview-free-skills___es"
  }, {
    path: "/preview/register-country",
    component: _193a1289,
    name: "preview-register-country___es"
  }, {
    path: "/solicitudes/reuniones",
    component: _72282dac,
    name: "solicitudes-reuniones___es"
  }, {
    path: "/empresas/agregar-ocupacion/detalle",
    component: _6b96cdfc,
    name: "empresas-agregar-ocupacion-detalle___es"
  }, {
    path: "/experiencias/nuevas/educativa",
    component: _779fda58,
    name: "experiencias-nuevas-educativa___es"
  }, {
    path: "/experiencias/nuevas/habilidades-educativas",
    component: _629b5a20,
    name: "experiencias-nuevas-habilidades-educativas___es"
  }, {
    path: "/experiencias/nuevas/habilidades-laborales",
    component: _4f3c0a90,
    name: "experiencias-nuevas-habilidades-laborales___es"
  }, {
    path: "/experiencias/nuevas/laboral",
    component: _0e136c82,
    name: "experiencias-nuevas-laboral___es"
  }, {
    path: "/experiencias/nuevas/otras",
    component: _595862fa,
    name: "experiencias-nuevas-otras___es"
  }, {
    path: "/ocupaciones-requeridas/cesantes/detalle",
    component: _82158288,
    name: "ocupaciones-requeridas-cesantes-detalle___es"
  }, {
    path: "/blog/categorias/:slug?",
    component: _38f49e3c,
    name: "blog-categorias-slug___es"
  }, {
    path: "/experiencias/educativa/:id?",
    component: _693abaa6,
    name: "experiencias-educativa-id___es"
  }, {
    path: "/experiencias/laboral/:id?",
    component: _3f726b4d,
    name: "experiencias-laboral-id___es"
  }, {
    path: "/experiencias/otra/:id?",
    component: _c2d16870,
    name: "experiencias-otra-id___es"
  }, {
    path: "/invitaciones/entrevistas/:user?",
    component: _3508e51e,
    name: "invitaciones-entrevistas-user___es"
  }, {
    path: "/invitaciones/enviadas/:code?",
    component: _8fbc5dc2,
    name: "invitaciones-enviadas-code___es"
  }, {
    path: "/mis-proyectos/antiguo/:id",
    component: _82fa5660,
    name: "mis-proyectos-antiguo-id___es"
  }, {
    path: "/oportunidades/reconversion-laboral/:id?",
    component: _3b197d52,
    name: "oportunidades-reconversion-laboral-id___es"
  }, {
    path: "/oportunidades/pilotos/:jobseekerfair/:id?",
    component: _0a147d56,
    name: "oportunidades-pilotos-jobseekerfair-id___es"
  }, {
    path: "/blog/:slug",
    component: _496439da,
    name: "blog-slug___es"
  }, {
    path: "/mis-proyectos/:id",
    component: _02381980,
    name: "mis-proyectos-id___es"
  }, {
    path: "/mis-trabajadores/:id?",
    component: _16aec693,
    name: "mis-trabajadores-id___es"
  }, {
    path: "/ocupaciones-personalizadas/:id",
    component: _42559a72,
    name: "ocupaciones-personalizadas-id___es"
  }, {
    path: "/ocupaciones/:id",
    component: _57cf4b26,
    name: "ocupaciones-id___es"
  }, {
    path: "/oportunidades/:id",
    component: _f581534c,
    name: "oportunidades-id___es"
  }, {
    path: "/piloto/:slug?",
    component: _052a8330,
    name: "piloto-slug___es"
  }, {
    path: "/ocupaciones-personalizadas/:id/agregar-habilidades",
    component: _486ca24a,
    name: "ocupaciones-personalizadas-id-agregar-habilidades___es"
  }, {
    path: "/mis-proyectos/:id?/ocupaciones/:occupationId",
    component: _bf3884ee,
    name: "mis-proyectos-id-ocupaciones-occupationId___es"
  }, {
    path: "/",
    component: _3d6810e8,
    name: "index___es"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
